<template>
  <div class="community-button inline-box" @click="goToCommunity">
    <v-icon font-size="2em">currents</v-icon>
  </div>
</template>

<script>
  export default {
    name: 'CommunityBtn',
    props: {
      communityUrl: {
        type: String,
        default: 'https://auchan-apps.easyvista.com/s/WIZZIT'
      }
    },
    methods: {
      goToCommunity() {
        window.open(this.communityUrl, '_blank')
      }
    }
  }

</script>

<style lang="scss" scoped>
  .community-button {
    cursor : pointer;
  }
</style>
